import {
    CONFIRMED_GET_FURNISHING_STATUS
} from '../actions/FurnishingStatus/FurnishingStatusTypes';
const initialState = {
    furnishingStatus: [],
    loading: false,
};

function FurnishingStatusReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'FURNISHING_STATUS_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_FURNISHING_STATUS:
            return {
                ...state,
                furnishingStatus: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {FurnishingStatusReducer};